import { Check, X } from 'lucide-react';
import { isValidSACell, normalizeSACell } from '@/lib/phone';

// Inline validation hint shown under a SA cellphone input.
// - empty: neutral guidance
// - valid: green tick + the canonical number it will be saved as
// - non-empty & invalid: red prompt to fix
export const CellphoneHint = ({ value }) => {
  const v = value || '';
  if (!v) {
    return (
      <p data-testid="cellphone-hint" className="mt-1.5 font-body text-[11px] text-foreground/50">
        Enter a 10-digit SA mobile number starting 06/07/08, e.g. 0821234567
      </p>
    );
  }
  const valid = isValidSACell(v);
  const normalized = valid ? normalizeSACell(v) : null;
  return (
    <div data-testid="cellphone-hint" className="mt-1.5 flex items-center gap-1.5">
      {valid ? (
        <>
          <Check className="h-3 w-3 text-green-400 flex-shrink-0" />
          <span className="font-body text-[11px] text-green-400" data-testid="cellphone-hint-normalized">
            Looks good{normalized ? ` — will be saved as ${normalized}` : ''}
          </span>
        </>
      ) : (
        <>
          <X className="h-3 w-3 text-red-400 flex-shrink-0" />
          <span className="font-body text-[11px] text-red-400">Enter a valid 10-digit SA cellphone</span>
        </>
      )}
    </div>
  );
};
